import { SvgIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { default as config } from '../../../../config';
import { commit, version } from '../../../../version.json';

export const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <footer className='flex h-footer items-center gap-20 bg-blue-dark-50 px-8 py-4 text-secondary-700'>
      {config.env !== 'prod' && (
        <div className='flex gap-2 text-xs font-medium'>
          <p className='capitalize-first'>{t('build:versionNumber', { version: version })}</p>
          <p className='capitalize-first'>{t('build:buildNumber', { build: commit })}</p>
        </div>
      )}
      <p className='text-xs font-medium'>{t('layout:platformName', { year: new Date().getFullYear() })}</p>
      <SvgIcon name='AudiencerateLogoIcon' className='ms-auto size-6' />
    </footer>
  );
};
